import request from '@/axios'

export function getTree() {
    return request({
        url: '/pay/room/treeList',
        method: 'get',
    })
}
// 查询公告列表
export function getList(data={}) {
    return request({
        url: '/info/notice/list',
        method: 'get',
        params: data
    })
}
// 某个公告
export function getListOnce(id) {
    return request({
        url: `/info/notice/info/${id}`,
        method: 'get',
    })
}

// 新增公告
export function addNotice(data={}) {
    return request({
        url: '/info/notice/save',
        method: 'post',
        data
    })
}
// 修改公告
export function updateNotice(data={}) {
    return request({
        url: '/info/notice/update',
        method: 'post',
        data
    })
}
// 删除公告
export function delNotice(data=[]) {
    return request({
        url: '/info/notice/delete',
        method: 'post',
        data
    })
}

